import { ComponentKey, ComponentTypeToRuleTypeMap } from "../constants";
import type { ProcessProps, Field, Step, Swimlane } from "../types";

export const checkValidComponentKey = (componentKey: ComponentKey) => {
  switch (componentKey) {
    case ComponentKey.SWIMLANES:
    case ComponentKey.STEPS:
    case ComponentKey.FIELDS:
    case ComponentKey.RULES:
    case ComponentKey.CONDITIONS:
    case ComponentKey.CONDITION_GROUPS:
    case ComponentKey.BULK_ACTIONS:
    case ComponentKey.EVENT_RULES:
    case ComponentKey.STATE_RULES:
      return true;
    default:
      return false;
  }
};

type Component = ProcessProps | Step | Field | Swimlane;

/**
 *
 * @param componentKey
 * @param component
 * @returns Components Array of rule ids
 */
export const getComponentRuleIds = (
  componentKey:
    | ComponentKey.STEPS
    | ComponentKey.SWIMLANES
    | ComponentKey.FIELDS
    | ComponentKey.PROCESS,
  component: Component
) => {
  return ComponentTypeToRuleTypeMap[componentKey].flatMap(
    ruleKey => component[ruleKey as unknown as keyof Component] || []
  ) as string[];
};
